import { useCallback } from 'react'

const useHoverScroll = () => {
  const handleMouseEnter = useCallback((e) => {
    e.currentTarget.style.overflow = 'auto'
  }, [])

  const handleMouseLeave = useCallback((e) => {
    e.currentTarget.style.overflow = 'hidden'
  }, [])

  return { handleMouseEnter, handleMouseLeave }
}

export default useHoverScroll
